import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse } from '@fortawesome/free-solid-svg-icons'

export default function NavBar({uno,due,tre,one,two,three}){

    let prevScrollpos = window.scrollY;
    window.onscroll = function() {
            
        let currentScrollPos = window.scrollY;
        if (prevScrollpos > currentScrollPos) {
            try {
                document.getElementById("navbar").style.top = "0";
            } catch (error) {
                return null;
            }
            
        } else {
            try {
                document.getElementById("navbar").style.top = "-60px";
            } catch (error) {
                return null;
            }
            
        }
        prevScrollpos = currentScrollPos;
    }

    return(

        <div id="navbar" style={{top:0}}>
                <Link to="/" className="iconaCasa"><FontAwesomeIcon icon={faHouse} /></Link>
                <Link to={one}>{uno}</Link>
                <Link to={two}>{due}</Link>
                <Link to={three}>{tre}</Link>
        </div>

    )
}